export enum ProjectRole {
    Manager = 0,
    Lead = 1,
    Dev = 2,
    Stakeholder = 3
}
